/* eslint no-param-reassign: 0 */
import axios from "axios";

const initialState = {};

const gettersDef = {};

const actions = {
  generateSignedUrl({ dispatch }, { data = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: "/brapp/upload-tokens/", data },
      { root: true }
    );
  },
  uploadFile(
    { dispatch },
    { file, bucketKey, options = { onProgress: null } }
  ) {
    const config = {
      headers: {
        "Content-Type": file.type
      },
      onUploadProgress(progressEvent) {
        if (options.onProgress) {
          options.onProgress(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        }
      }
    };

    return dispatch("generateSignedUrl", {
      data: { contentType: file.type, filename: file.name, bucketKey }
    }).then(({ url, path, fullUrl }) =>
      axios.put(url, file, config).then(() => ({ path, fullUrl }))
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
